namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_catalog, {

		Public_icon: {
			align: {
				self: 'center',
			},
		},

		Menu_item: {
			position: 'relative',
			width: '100%',
			minWidth: 0,
		},

		Menu_link: {
			width: '100%',
			minWidth: 0,
			padding: {
				right: '4rem',
			},
		},

		Map_title: {
			width: '100%',
			minWidth: 0,
		},

		Map_title_input: {
			width: '100%',
		},

		Map_menu_links: {
			flex: {
				direction: 'column',
			},
		},

		Owned_tree: {
			width: '100%',
		},

		Owned_tree_item: {
			width: '100%',
			minWidth: 0,
		},

		Project_item: {
			width: '100%',
			minWidth: 0,
			alignItems: 'flex-start',
		},

		Project_title: {
			width: '100%',
			justifyContent: 'flex-start',
			alignItems: 'flex-start',
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
		},

		Project_menu: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			width: '100%',
			minWidth: 0,
		},

		Project_undo: {
			width: '100%',
			justifyContent: 'flex-start',
		},

		Project_title_input: {
			width: '100%',
		},

		Project_icon: {
			flex: {
				shrink: 0,
			},
			opacity: 0.5,
		},

		Project_title_text: {
			display: 'block',
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: 0,
			overflow: 'visible',
			textOverflow: 'clip',
			whiteSpace: 'normal',
			overflowWrap: 'anywhere',
		},

		Visited_title: {
			color: $mol_theme.shade,
		},
		Available_title: {
			color: $mol_theme.shade,
		},

		Favorite_action: {
			position: 'absolute',
			top: '50%',
			right: 0,
			transform: 'translateY( -50% )',
			height: 'auto',
			background: {
				color: 'var(--mol_theme_back)' as any,
			},
			opacity: 0,
			pointerEvents: 'none',
			zIndex: 1,
		},

		Editor_mode_action: {
			position: 'absolute',
			top: '50%',
			right: '2rem',
			transform: 'translateY( -50% )',
			height: 'auto',
			background: {
				color: 'var(--mol_theme_back)' as any,
			},
			opacity: 0,
			pointerEvents: 'none',
			zIndex: 1,
		},

		Favorite: {
			width: '2rem',
			height: '2rem',
			background: {
				color: 'var(--mol_theme_card)' as any,
			},
		},

		Editor_mode: {
			width: '2rem',
			height: '2rem',
			background: {
				color: 'var(--mol_theme_card)' as any,
			},
		},

		Menu_title: {
			flex: {
				grow: 0,
			},
		},

		List_head: {
			flex: {
				grow: 1,
			},
		},

		Add_map_anchor: {
			cursor: 'default',
		},

	} )

}
